<template>
  <img width="24" height="24" src="../../../../../images/icons/search.png" alt="検索アイコン" />
</template>
